// import './border.scss';
import './ui-brand.scss';
import Brand from "./brand-bar";
import "core-js";
import "regenerator-runtime";

import Vue from "vue";
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sm: 768,
    md: 1422,
    lg: Infinity,
  }
})


// for babel checking 
// var stuff = new WeakSet([]);

// Create Element.remove() function if not exist
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function() {
      if (this.parentNode) {
          this.parentNode.removeChild(this);
      }
  };
}

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}


function _docReady(fn) {
  // see if DOM is already available, if so just run the function 
  if (document.readyState === "complete" || document.readyState === "interactive") {
      // call on next available tick
      setTimeout(fn, 1);
  } else {
      // dom is not available so apply the function to the DomContentLoaded Event
      document.addEventListener("DOMContentLoaded", fn);
  }
}

_docReady(createVue);
function createVue(){
 
  let brandApp = new Vue(Brand)
 
   Vue.prototype.$appname = 'ui-brand';
   window.brand = {};
   window.hideMenu = brandApp.$root.hideMenu;
   window.hideAccount = brandApp.$root.hideAccount;
   window.brand.hideAccount = brandApp.$root.setActiveNav;
   window.brand.setActiveNav = brandApp.$root.setActiveNav;
   window.brand.setUser = brandApp.$root.setUser;
   window.brand.removeNavLink = brandApp.$root.removeNavLink;
   window.brand.removeAccountLink= brandApp.$root.removeAccountLink;
   window.brand.setCloak = brandApp.$root.setCloak;
}

function toggleBrand(toggle){
  if ('URLSearchParams' in window) {
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.set("martymcfly", toggle);
    let search  = '?'+searchParams.toString();
    let hash = window.location.hash;
    window.location.href= search + hash;
  }
};

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

window.toggleBrand = toggleBrand;
window.getUrlParameter = getUrlParameter;
